export class ChangePasswordInput{
    crmUserId:number;
   sessionToken:string;
   password:string;
   confirmPassword:string;
  
}